<template>
  <div class="wm-set-box border_box">
    <wmerrortips :errmsg="errmsg">
      <template v-if="!loading">
        <div class="wm-set-list-box border_box">
          <div class="wm-switch-box border_box item-vertical">
            <div class="switch-txt">固定表述</div>
            <div class="switch-btn">
              <van-switch v-model="fixedchecked" disabled/>
            </div>
          </div>
          <div class="set-collapse-box border_box">
            <div
              class="set-collapse-title-box border_box item-vertical"
              :class="isShowLevel ? ' no-btom-border' : ''"
              @click.stop="handlerLevel"
            >
              <div class="set-collapse-title">错敏级别</div>
              <i class="arrow-down-icon border_box" :class="isShowLevel ? ' openedarrow' :'closedarrow'"></i>
            </div>
            <div class="set-collapse-content-box border_box media-content" v-show="isShowLevel">
              <div class="media-type-item-box border_box" v-for="(level,l) of levelArr"
                :key="'level'+Math.random()+l"
                :class="[
                  level.isactive ? ' active' : ''
                ]"
                @click.stop="level.isselected ? changeLevel(level,1) : changeLevel(level,2)"
              >{{level.name}}</div>
            </div>
          </div>
          <div class="set-collapse-box border_box error-classify-collapse">
            <div
              class="set-collapse-title-box border_box item-vertical"
              :class="isShowErrorClassity ? ' no-btom-border' : ''"
              @click.stop="handlerErrorClassity"
            >
              <div class="set-collapse-title">错敏分类</div>
              <i class="arrow-down-icon border_box" :class="isShowErrorClassity ? ' openedarrow' :'closedarrow'"></i>
            </div>
            <div class="set-collapse-content-box border_box error-classity-content"  v-show="isShowErrorClassity">
              <div class="error-classify-all-box border_box item-vertical">
                <div class="com-checkbox-box border_box">
                  <div class="com-check-content flex_verticle">
                    <i
                      class="cus-checkbox border_box"
                      :class="[
                        checkedall ? 'checked' : '',
                        checkedhalf ? 'half-checked' : ''
                      ]"
                      @click.stop="clickAllCheck"
                    ></i>
                    <span class="cus-txt border_box">全选</span>
                  </div>
                </div>
                <div class="classify-err-txt" v-show="errclassifyObj.isshow">{{errclassifyObj.text}}</div>
              </div>
              <div class="error-classify-ops-box border_box flex">
                <div class="error-classify-ops-left-box border_box flex_1">
                  <div
                    class="com-checkbox-box border_box"
                    v-for="(eror,e) of errorclassifyArr"
                    :key="'errorclassify'+Math.random()+e"
                    :class="[activeClassify === eror.value ? 'activeclassify': '']"
                  >
                    <div class="com-check-content flex_verticle">
                      <i
                        class="cus-checkbox border_box"
                        :class="[
                          eror.checked ? 'checked' : '',
                          eror.checkedhalf ? 'half-checked' : ''
                        ]"
                        @click.stop="clickLeftCheck(eror)"
                      ></i>
                      <span class="cus-txt border_box" @click.stop="clickLeftTxt(eror)">{{eror.name}}</span>
                    </div>
                  </div>
                </div>
                <div class="error-classify-ops-right-box border_box flex_1" v-show="activeClassify.length && activeClassify !== '5'">
                  <!-- 领导人核心 - 子项 -->
                  <div
                    v-show="activeClassify === '1'"
                    class="com-checkbox-box border_box"
                    v-for="(er1,e1) of errorarr1"
                    :key="'errorclassify1'+Math.random()+e1"
                  >
                    <div class="com-check-content flex_verticle">
                      <i
                        class="cus-checkbox border_box"
                        :class="[
                          er1.checked ? 'checked' : ''
                        ]"
                        @click.stop="clickOne(er1)"
                      ></i>
                      <span class="cus-txt border_box">{{er1.name}}</span>
                    </div>
                  </div>
                  <!-- 重大节点 - 子项 -->
                  <div
                    v-show="activeClassify === '2'"
                    class="com-checkbox-box border_box"
                    v-for="(er2,e2) of errorarr2"
                    :key="'errorclassify2'+Math.random()+e2"
                  >
                    <div class="com-check-content flex_verticle">
                      <i
                        class="cus-checkbox border_box"
                        :class="[
                          er2.checked ? 'checked' : ''
                        ]"
                        @click.stop="clickTwo(er2)"
                      ></i>
                      <span class="cus-txt border_box">{{er2.name}}</span>
                    </div>
                  </div>
                  <!-- 政治安全 - 子项 -->
                  <div
                    v-show="activeClassify === '3'"
                    class="com-checkbox-box border_box"
                    v-for="(er3,e3) of errorarr3"
                    :key="'errorclassify3'+Math.random()+e3"
                  >
                    <div class="com-check-content flex_verticle">
                      <i
                        class="cus-checkbox border_box"
                        :class="[
                          er3.checked ? 'checked' : ''
                        ]"
                        @click.stop="clickThree(er3)"
                      ></i>
                      <span class="cus-txt border_box">{{er3.name}}</span>
                    </div>
                  </div>
                  <!-- 社会民生 - 子项 -->
                  <div
                    v-show="activeClassify === '4'"
                    class="com-checkbox-box border_box"
                    v-for="(er4,e4) of errorarr4"
                    :key="'errorclassify4'+Math.random()+e4"
                  >
                    <div class="com-check-content flex_verticle">
                      <i
                        class="cus-checkbox border_box"
                        :class="[
                          er4.checked ? 'checked' : ''
                        ]"
                        @click.stop="clickFour(er4)"
                      ></i>
                      <span class="cus-txt border_box">{{er4.name}}</span>
                    </div>
                  </div>
                  <!-- 一般错别字 - 子项 -->
                  <div
                    v-show="activeClassify === '110' && checkInfoObj.open110 === 1"
                    class="com-checkbox-box border_box"
                    v-for="(er6,e6) of errorarr6"
                    :key="'errorclassify6'+Math.random()+e6"
                  >
                    <div class="com-check-content flex_verticle">
                      <i
                        class="cus-checkbox border_box"
                        :class="[
                          er6.checked ? 'checked' : ''
                        ]"
                        @click.stop="clickSix(er6)"
                      ></i>
                      <span class="cus-txt border_box">{{er6.name}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="set-collapse-box border_box">
            <div
              class="set-collapse-title-box border_box item-vertical"
              :class="isShowMdeia ? ' no-btom-border' : ''"
              @click.stop="handlerMedia"
            >
              <div class="set-collapse-title">媒体类型</div>
              <i class="arrow-down-icon border_box" :class="isShowMdeia ? ' openedarrow' :'closedarrow'" ></i>
            </div>
            <div class="set-collapse-content-box border_box media-content" v-show="isShowMdeia">
              <div class="media-type-item-box border_box" v-for="(media,m) of mediaTypeArr"
                :key="'media'+Math.random()+m"
                :class="media.isactive ? ' active' : ''"
                @click.stop="changeMedia(media)"
              >{{media.name}}</div>
            </div>
          </div>
          <div class="set-collapse-box border_box cursor" @click.stop="goToAccountlist">
            <div class="set-collapse-title-box border_box item-vertical">
              <div class="set-collapse-title">媒体账号</div>
              <i class="arrow-down-icon border_box arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="wm-set-list-box border_box">
          <div class="wm-switch-box border_box item-vertical no-btom-border">
            <div class="switch-txt">僵尸信源</div>
            <div class="switch-btn">
              <van-switch v-model="zombiechecked"/>
            </div>
          </div>
          <div class="wm-zombie-content-box border_box" v-show="zombiechecked">
            <div class="zombie-title">未更新天数：</div>
            <div class="zombie-input border_box flex">
              <v-edit-div v-model='zombiedays' class="zombie-input-item border_box flex_verticle flex_1" placeholder="请输入3~366之间的任意数字"></v-edit-div>
              <div class="zombie-unit">天</div>
            </div>
            <div class="zombie-err-txt" v-show="zombieerrObj.isshow">{{zombieerrObj.text}}</div>
            <div class="zombie-title">信源来源：</div>
            <div class="zombie-content flex-verticle">
              <div 
                class="zombie-item-box border_box"
                v-for="(zbe,z) of zombieArr"
                :key="'zombie'+Math.random()+z"
                :class="zbe.isactive ? ' active' : ''"
                @click.stop="changeZombie(zbe)"
              >{{zbe.name}}</div>
            </div>
          </div>
        </div>
        <div class="wm-set-list-box border_box">
          <div class="wm-switch-box border_box item-vertical no-btom-border">
            <div class="switch-txt">网站扫描</div>
            <div class="switch-btn">
              <van-switch v-model="sitescanchecked"/>
            </div>
          </div>
        </div>
        <div class="wm-set-fixed-btn-box border_box flex-right">
          <div class="sure-btn-box border_box" @click.stop="handlerSave">确定</div>
        </div>
      </template>
    </wmerrortips>
    <!-- 预加载图片 -->
    <div class="preview-img" v-show="false">
      <img :src="imgObj.unchecked" alt="">
      <img :src="imgObj.checked" alt="">
      <img :src="imgObj.halfchecked" alt="">
    </div>
  </div>
</template>
<script>
import vEditDiv from '@/components/editdiv/editdiv.vue'
import wmerrortips from './errortips.vue'
import { Switch, Toast } from 'vant';
import Clickoutside from '@/directives/clickoutside'
import { geterrorclassify } from '@/api/wmset'
import { getCode } from '@/api/fixedstatementerror'
import { getSettinginfo, settingadd } from '@/api/wmset'
export default {
  name:'wmSet', 
  directives: {
    Clickoutside
  },
   components: {
      vEditDiv,
      wmerrortips,
      "van-switch": Switch
    },
  data(){
    return {
      imgObj:{
        unchecked: require('../../assets/images/wmSet/unchecked.svg'),
        checked: require('../../assets/images/wmSet/checked.svg'),
        halfchecked: require('../../assets/images/wmSet/half-checked.svg')
      },
      errmsg: 0, // 错误信息值 200无错
      loading: false,
      fixedchecked: true, // 固定表述选中
      zombiechecked: false, // 僵尸信源-选中
      zombiedays: '14', // 僵尸信源-未更新天数
      zombieerrObj: {
        isshow: false, // 僵尸信源-未更新天数-校验信息
        text: ''
      },
      zombiesiteSource: [], // 僵尸信源-信源来源-选中的项
      zombieArr: [
        {
          value: '2',
          name: '手动补充',
          isactive: true // 默认选中
        },
        {
          value: '1',
          name: '系统推荐',
          isactive: false
        },
      ],
      sitescanchecked: false, // 网站扫描选中
      isShowMdeia: false,
      mediaAllOps: ['01','04','06','20','12','11','13','19','14','18','16','17'], // 媒体类型-全选时的值
      mediaChecked: ['01','04','06','20','12','11','13','19','14','18','16','17'], // 媒体类型-选中的项
      mediaTypeArr: [ // 媒体类型 - 默认没有选中
        { name: '全部', type: 'all', isactive: true },
        { name: '网站', type: '01', isactive: false },
        { name: '微博', type: '04', isactive: false },
        { name: '微信公众号', type: '06', isactive: false },
        { name: 'APP', type: '20', isactive: false },
        { name: '今日头条', type: '12', isactive: false },
        { name: '短视频', type: '11', isactive: false },
        { name: '百度贴吧', type: '13', isactive: false },
        { name: '大风号', type: '19', isactive: false },
        { name: '百家号', type: '14', isactive: false },
        { name: '搜狐号', type: '18', isactive: false },
        { name: '网易号', type: '16', isactive: false },
        { name: '企鹅号', type: '17', isactive: false }
      ],
      isShowLevel: false,
      levelChecked: ['3'], // 错敏级别 - 默认严重，必勾项
      levelArr: [ // 错敏级别 - 控制选中状态的数组
        {
          value: '3',
          name: '严重',
          isactive: true,
          isselected: false // 是否允许点选
        },
        {
          value: '2',
          name: '一般',
          isactive: false,
          isselected: true
        },
        {
          value: '1',
          name: '轻微',
          isactive: false,
          isselected: true        
        }
      ],
      isShowErrorClassity: false, // 错敏分类
      errclassifyObj: {
        isshow: false, // 错敏分类-校验信息
        text: ''
      },
      checkedall: false, // 错敏分类-全选是否选中
      checkedhalf: false, // 错敏分类-全选-半选
      errorclassifyall: [ // 错敏分类-全选时的值
        // {
        //   key: '1',
        //   value: ["6","7"]
        // },
        // {
        //   key: '2',
        //   value: ["8","9","10","83"]
        // },
        // {
        //   key: '3',
        //   value: ["11","12","13","14"]
        // },
        // {
        //   key: '4',
        //   value: ["15","16","17"]
        // },
        // {
        //   key: '5',
        //   value: ["1"]
        // },
        // {
        //   key: '110',
        //   value: ["111","112","113"]
        // }
      ],
      errorclassifyArr: [ // 错敏分类 - 一级选项
        // {
        //   value: '1',
        //   name: '领导人核心',
        //   checked: false,
        //   checkedhalf: false
        // },
        // {
        //   value: '2',
        //   name: '重大节点',
        //   checked: false,
        //   checkedhalf: false
        // },
        // {
        //   value: '3',
        //   name: '政治安全',
        //   checked: false,
        //   checkedhalf: false
        // },
        // {
        //   value: '4',
        //   name: '社会民生',
        //   checked: false,
        //   checkedhalf: false
        // },
        // {
        //   value: '5',
        //   name: '自定义错敏词库',
        //   checked: false,
        //   checkedhalf: false
        // },
        // {
        //   value: '110',
        //   name: '一般错别字',
        //   checked: false,
        //   checkedhalf: false
        // }
      ],
      activeClassify: '', // 错敏分类左侧 - 高亮的项
      checked1: [], // 领导人核心-选中的项
      checked2: [], // 重大节点-选中的项
      checked3: [], // 政治安全-选中的项
      checked4: [], // 社会民生-选中的项
      checked5: [], // 自定义错敏词库-选中的项
      checked6: [], // 一般错别字-选中的项
      errorarr1: [ // 领导人核心 - 遍历arr
        // {
        //   key: '1',
        //   value: '6',
        //   name: '涉习',
        //   checked: false
        // },
        // {
        //   key: '1',
        //   value: '7',
        //   name: '国家领导人',
        //   checked: false
        // }
      ], 
      errorarr2: [ // 重大节点 - 遍历arr
        // {
        //   key: '2',
        //   value: '8',
        //   name: '二十大专题',
        //   checked: false
        // },
        // {
        //   key: '2',
        //   value: '9',
        //   name: '十九大专题',
        //   checked: false
        // },
        // {
        //   key: '2',
        //   value: '10',
        //   name: '建党一百周年',
        //   checked: false
        // },
        // {
        //   key: '2',
        //   value: '83',
        //   name: '两会专题',
        //   checked: false
        // }
      ],
      errorarr3: [ // 政治安全 - 遍历arr
        // {
        //   key: '3',
        //   value: '11',
        //   name: '国家政策',
        //   checked: false
        // },
        // {
        //   key: '3',
        //   value: '12',
        //   name: '法律法规',
        //   checked: false
        // },
        // {
        //   key: '3',
        //   value: '13',
        //   name: '党史党建',
        //   checked: false
        // },
        // {
        //   key: '3',
        //   value: '14',
        //   name: '机构名称',
        //   checked: false
        // }
      ], 
      errorarr4: [ // 社会民生 - 遍历arr
        // {
        //   key: '4',
        //   value: '15',
        //   name: '人文地理',
        //   checked: false
        // },
        // {
        //   key: '4',
        //   value: '16',
        //   name: '近现代史',
        //   checked: false
        // },
        // {
        //   key: '4',
        //   value: '17',
        //   name: '国际相关',
        //   checked: false
        // }
      ],
      errorarr6: [ // 一般错别字 - 遍历arr
        // {
        //   key: '110',
        //   value: '111',
        //   name: '语句语法',
        //   checked: false
        // },
        // {
        //   key: '110',
        //   value: '112',
        //   name: '错别字词',
        //   checked: false
        // },
        // {
        //   key: '110',
        //   value: '113',
        //   name: '标点符号',
        //   checked: false
        // }
      ],
      checkInfoObj: {}, // 用户设置的预警设置信息 
    }
  },
  created(){
    // 预警设置页面，更改网页ico
    let pageUrl = this.$route.path
    if(pageUrl === '/wmset'){
      document.querySelector("link.linkico").href = "./wmico.ico";
    }else{
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
    // 本地调试时，放开
    // localStorage.setItem("wlgl-token", '7f507d5b3a748b08e0a7c1f48eafdd82')
    // localStorage.setItem("wlgl-openId", 'o-gL86mYoMZUcvsXTHPZk75jgz9Q')
  },
  computed: {
    checkedall1() { // 领导人核心-全选时的值
      return this.errorclassifyall.find(it => it.key === '1').value
    },
    checkedall2() {
      return this.errorclassifyall.find(it => it.key === '2').value
    },
    checkedall3() {
      return this.errorclassifyall.find(it => it.key === '3').value
    },
    checkedall4() {
      return this.errorclassifyall.find(it => it.key === '4').value
    },
    checkedall5() {
      return this.errorclassifyall.find(it => it.key === '5').value
    },
    checkedall6() {
      // return this.errorclassifyall.find(it => it.key === '110').value
      const item = this.errorclassifyall.find(it => it.key === '110')
      return item ? item.value : [] // 如果没有找到，则返回空数组
    }
  },
  mounted(){
    if (localStorage.getItem("wlgl-token") && localStorage.getItem("wlgl-openId")) {
      this.queryErrorClassify()
    }else if (!!localStorage.getItem("wlgl-token") == '' && Object.keys(this.$route.query).length === 0){
      this.errmsg = 20016
    }else{
      this.init()
    }
  },
  methods:{
    init(){
      if (Object.keys(this.$route.query).length) {
        const code = this.$route.query.code
        const state = this.$route.query.state
        this.queryCode(code,state)
      }
    },
    // 获取 wlgl-token
    queryCode(code,state){
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      this.loading = true
      getCode({
        code: code,
        state: state
      }).then(res=>{
        if (res.data.code === 200){
          this.errmsg = 200
          localStorage.setItem("wlgl-token", res.data.data)
          localStorage.setItem("wlgl-openId", res.data.openId)
          this.queryErrorClassify()
        }else{
          this.errmsg = res.data.code
        }
      }).catch(err=>{
        Toast.clear()
        console.log(err);
      });
    },
    // 清数据 - 错敏分类
    clearErrorClassifyParams(){
      // 错敏分类 - 全选时的值
      this.errorclassifyall = []
      // 错敏分类 - 一级选项
      this.errorclassifyArr = []
      // 二级选项 - 领导人核心
      this.errorarr1 = []
      // 二级选项 - 重大节点
      this.errorarr2 = []
      // 二级选项 - 政治安全
      this.errorarr3 = []
      // 二级选项 - 社会民生
      this.errorarr4 = []
      // 二级选项 - 一般错别字
      this.errorarr6 = []
    },
    // 二级选项数组数据处理
    handlerTwolevelArr(item){
      // errorarr1/errorarr2/errorarr3/errorarr4/errorarr6 二级选项数组数据处理
      // 使用 map 方法处理 children 数组，构建新的目标数组项
      const mappedChildren = item.children.map(child => ({
          key: String(item.id),
          value: String(child.id),
          name: child.name,
          checked: false
      }))
      // 判断当前项是否有 children 属性，根据 item.id 的值分别存入不同的目标数组
      switch (String(item.id)) {
        case "1":
          this.errorarr1 = [...this.errorarr1, ...mappedChildren]
          break;
        case "2":
          this.errorarr2 = [...this.errorarr2, ...mappedChildren]
          break;
        case "3":
          this.errorarr3 = [...this.errorarr3, ...mappedChildren]
          break;
        case "4":
          this.errorarr4 = [...this.errorarr4, ...mappedChildren]
          break;
        case "110":
          this.errorarr6 = [...this.errorarr6, ...mappedChildren]
          break;
        default:
          break;
      }
    },
    // 查询错敏分类
    queryErrorClassify(){
      this.clearErrorClassifyParams()
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      this.loading = true
      geterrorclassify().then(res=>{
        this.errmsg = res.data.code
        if (res.data.code === 200){
          let result =   res.data.data || []
          result.forEach((item) => {
            // errorclassifyall 处理
            // 检查是否有 children 属性
            if (item.children) {
              // 如果有 children，提取 children 中每个对象的 id，组成一个数组
              const values = item.children.map(child => String(child.id))
              // 将提取的数据添加到 errorclassifyall 数组中
              this.errorclassifyall.push({ key: String(item.id), value: values })

              // 二级选项数组数据处理
              this.handlerTwolevelArr(item)
            } else {
              // 如果没有 children，自定义错敏词库，选中存1
              this.errorclassifyall.push({ key: String(item.id), value: ["1"] })
            }
            
            // 错敏分类 - 一级选项 errorclassifyArr 处理
            let newItem = {
              value: String(item.id),
              name: item.name,
              checked: false,
              checkedhalf: false
            }
            this.errorclassifyArr.push(newItem)  
          })
          
          result.length && this.querySettingInfo()
        }else if (res.data.code === 20009){
          Toast.clear()
          this.loading = false
          // token 失效
          this.init()
        }else{
          Toast.clear()
          this.loading = false
        }
      }).catch(err=>{
        Toast.clear()
        console.log(err)
      })
    },
    // 清数据 - 各类设置
    clearSettingInfoParams(){
      this.fixedchecked = true
      this.levelChecked = ['3']
      this.mediaChecked = []
      this.checked1 = []
      this.checked2 = []
      this.checked3 = []
      this.checked4 = []
      this.checked5 = []
      this.checked6 = []
      this.zombiechecked = false
      this.zombiedays = '14'
      this.zombiesiteSource = ['2']
      this.sitescanchecked = false
    },
    // 查询自定义设置的错敏分类
    querySettingInfo(){
      this.clearSettingInfoParams()
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      this.loading = true
      getSettinginfo({
        openId: localStorage.getItem("wlgl-openId")
      }).then(res=>{
        this.errmsg = res.data.code
        Toast.clear()
        if (res.data.code === 200){
          Toast.clear()
          this.loading = false
          const result = res.data.data
          this.checkInfoObj = result || {}
          // 各类型数据、开启或勾选 - 数据处理
          // 固定表述
          this.fixedchecked = result.violationJsonObj.isOpen === 1 ? true : false
          // 错敏级别
          this.levelChecked = result.violationJsonObj.level
          this.levelArr.forEach(ele => {
            if (this.levelChecked.includes(ele.value)) {
              ele.isactive = true
            } else {
              ele.isactive = false
            }
          })
          // 错敏分类
          const arr = result.violationJsonObj.classifyLevelIdList
          this.checked1 = arr.find(item => item.key === '1').value || []
          this.checked2 = arr.find(item => item.key === '2').value || []
          this.checked3 = arr.find(item => item.key === '3').value || []
          this.checked4 = arr.find(item => item.key === '4').value || []
          this.checked5 = arr.find(item => item.key === '5').value === 1 ? ["1"]: []

          // 0关 1开
          if(this.checkInfoObj.open110 === 1){
            this.checked6 = arr.find(item => item.key === '110').value || []
          }else{
            this.checked6 = []
          }

          // 更新全选的状态
          this.updateAllCheck()
          // 更新左侧一级子项，勾选的状态（全选、半选、不选）
          this.errorclassifyArr.forEach(item => {
            // 在 arr 中找到对应的项
            const matchingItem = arr.find(e => e.key === item.value)
            if (matchingItem) {
              let subchecked // 子项勾选的值
              let suballchecked // 子项全勾选的值
              // 根据 key 选择对应的 checked 和 checkedall 数组
              switch (item.value) {
                case '1':
                  subchecked = this.checked1
                  suballchecked = this.checkedall1
                  break;
                case '2':
                  subchecked = this.checked2
                  suballchecked = this.checkedall2
                  break;
                case '3':
                  subchecked = this.checked3
                  suballchecked = this.checkedall3
                  break;
                case '4':
                  subchecked = this.checked4
                  suballchecked = this.checkedall4
                  break;
                case '5':
                  subchecked = this.checked5
                  suballchecked = this.checkedall5
                  break;
                case '110':
                  subchecked = this.checked6
                  suballchecked = this.checkedall6
                  break;
                default:
                  subchecked = []
                  suballchecked = []
                  break;
              }

              // 检查匹配到的 子项勾中 数组的长度 与 子项全勾 数组的长度是否相等
              item.checked = subchecked.length === suballchecked.length
              item.checkedhalf = subchecked.length > 0 &&  subchecked.length < suballchecked.length
            }
          })
          // 更新右侧二级子项，勾选的状态（全选、不选）
          this.errorarr1 = this.errorarr1.map(item => ({
            ...item,
            checked: this.checked1.includes(item.value) ? true : false
          }))
          this.errorarr2 = this.errorarr2.map(item => ({
            ...item,
            checked: this.checked2.includes(item.value) ? true : false
          }))
          this.errorarr3 = this.errorarr3.map(item => ({
            ...item,
            checked: this.checked3.includes(item.value) ? true : false
          }))
          this.errorarr4 = this.errorarr4.map(item => ({
            ...item,
            checked: this.checked4.includes(item.value) ? true : false
          }))
          // 0关 1开
          if(this.checkInfoObj.open110 === 1){
            this.errorarr6 = this.errorarr6.map(item => ({
              ...item,
              checked: this.checked6.includes(item.value) ? true : false
            }))
          }
          
          // 媒体类型 - 若是全选，只选中全部，其他不选中
          this.mediaChecked = result.violationJsonObj.siteTypeList.selected
          if(this.mediaTypeArr.length - 1 === this.mediaChecked.length){
            this.mediaTypeArr = this.mediaTypeArr.map(item => ({
              ...item,
              isactive: item.type === 'all' ? true : false
            }))
          }else{
            this.mediaTypeArr = this.mediaTypeArr.map(item => ({
              ...item,
              isactive: this.mediaChecked.includes(item.type) ? true : false
            }))
          }
          // 僵尸信源
          this.zombiechecked = result.corpseJsonObj.isOpen === 1 ? true : false
          this.zombiedays = result.corpseJsonObj.days.toString()
          this.zombiesiteSource = result.corpseJsonObj.siteSource
          this.zombieArr = this.zombieArr.map(item => ({
            ...item,
            isactive: this.zombiesiteSource.includes(item.value) ? true : false
          }))
          // 网站扫描
          this.sitescanchecked = result.scanJsonObj.isOpen === 1 ? true : false
        }else if (res.data.code === 20009){
          Toast.clear()
          this.loading = false
          // token 失效
          this.init()
        }else{
          Toast.clear()
          this.loading = false
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // 错敏分类 - 全选
    clickAllCheck(){
      this.checkedall = !this.checkedall
      this.checkedhalf = false
      this.checked1 = this.checkedall ? this.checkedall1 : []
      this.checked2 = this.checkedall ? this.checkedall2 : []
      this.checked3 = this.checkedall ? this.checkedall3 : []
      this.checked4 = this.checkedall ? this.checkedall4 : []
      this.checked5 = this.checkedall ? this.checkedall5 : []
      this.checked6 = this.checkedall ? this.checkedall6 : []
      // 更新左侧一级子项，勾选的状态
      this.errorclassifyArr.forEach((ele) => {
        this.$set(ele, 'checked', this.checkedall)
        this.$set(ele, 'checkedhalf', false)
      })
      // 更新右侧二级子项，勾选的状态
      this.errorarr1.forEach((ele) => {
        this.$set(ele, 'checked', this.checkedall)
      })
      this.errorarr2.forEach((ele) => {
        this.$set(ele, 'checked', this.checkedall)
      })
      this.errorarr3.forEach((ele) => {
        this.$set(ele, 'checked', this.checkedall)
      })
      this.errorarr4.forEach((ele) => {
        this.$set(ele, 'checked', this.checkedall)
      })
      // 0关 1开
      if(this.checkInfoObj.open110 === 1){
        this.errorarr6.forEach((ele) => {
          this.$set(ele, 'checked', this.checkedall)
        })
      }

      // 更新校验
      this.updatevalidate()
    },
    // 错敏分类 - 更新校验
    updatevalidate(){
      // const arr = [].concat(this.checked1,this.checked2,this.checked3,this.checked4,this.checked5,this.checked6)
      let arr = []
      // 0关 1开
      if(this.checkInfoObj.open110 === 1){
        arr = [].concat(this.checked1,this.checked2,this.checked3,this.checked4,this.checked5,this.checked6)
      }else{
        arr = [].concat(this.checked1,this.checked2,this.checked3,this.checked4,this.checked5)
      }

      if(arr.length === 0){
        this.errclassifyObj.isshow = true
        this.errclassifyObj.text = '不能为空，至少选择一项！'
        return false
      }else{
        this.errclassifyObj.isshow = false
        this.errclassifyObj.text = ''
        return true
      }
    },
    // 错敏分类 - 左侧 - 点击 checkbox
    clickLeftCheck(item){
      // 半选关闭
      this.$set(item, 'checkedhalf', false)
      // 更新侧一级子项的状态
      if(item.value === '1'){
        this.checked1 = []
        this.$set(item, 'checked', !item.checked)
        this.checked1 = item.checked ? this.checkedall1 : []
        // 更新二级子项勾选状态
        this.errorarr1.forEach((ele) => {
          this.$set(ele, 'checked', item.checked)
        })
      }
      if(item.value === '2'){
        this.checked2 = []
        this.$set(item, 'checked', !item.checked)
        this.checked2 = item.checked ? this.checkedall2 : []
        // 更新二级子项勾选状态
        this.errorarr2.forEach((ele) => {
          this.$set(ele, 'checked', item.checked)
        })
      }
      if(item.value === '3'){
        this.checked3 = []
        this.$set(item, 'checked', !item.checked)
        this.checked3 = item.checked ? this.checkedall3 : []
        // 更新二级子项勾选状态
        this.errorarr3.forEach((ele) => {
          this.$set(ele, 'checked', item.checked)
        })
      }
      if(item.value === '4'){
        this.checked4 = []
        this.$set(item, 'checked', !item.checked)
        this.checked4 = item.checked ? this.checkedall4 : []
        // 更新二级子项勾选状态
        this.errorarr4.forEach((ele) => {
          this.$set(ele, 'checked', item.checked)
        })
      }
      if(item.value === '5'){
        this.checked5 = []
        this.$set(item, 'checked', !item.checked)
        this.checked5 = item.checked ? this.checkedall5 : []
      }
      // 0关 1开
      if(this.checkInfoObj.open110 === 1){
        if(item.value === '110'){
          this.checked6 = []
          this.$set(item, 'checked', !item.checked)
          this.checked6 = item.checked ? this.checkedall6 : []
          // 更新二级子项勾选状态
          this.errorarr6.forEach((ele) => {
            this.$set(ele, 'checked', item.checked)
          })
        }
      }
      // 更新全选的状态
      this.updateAllCheck()
    },
    // 错敏分类 - 左侧 - 点击 checkbox - 更新全选的状态
    updateAllCheck(){
      // 更新全选的状态（全选 checkedall 、半选 checkedhalf ）
      // const arr = [].concat(this.checked1,this.checked2,this.checked3,this.checked4,this.checked5,this.checked6)
      // const allarr = [].concat(this.checkedall1,this.checkedall2,this.checkedall3,this.checkedall4,this.checkedall5,this.checkedall6)
      // this.checkedall = arr.length === allarr.length
      // this.checkedhalf = arr.length > 0 && arr.length < allarr.length

      let checkedArray, checkedAllArray;

      // 判断 open110 是否为 1，决定合并的数组范围
      if (this.checkInfoObj.open110 === 1) {
          checkedArray = [].concat(this.checked1, this.checked2, this.checked3, this.checked4, this.checked5, this.checked6);
          checkedAllArray = [].concat(this.checkedall1, this.checkedall2, this.checkedall3, this.checkedall4, this.checkedall5, this.checkedall6);
      } else {
          checkedArray = [].concat(this.checked1, this.checked2, this.checked3, this.checked4, this.checked5);
          checkedAllArray = [].concat(this.checkedall1, this.checkedall2, this.checkedall3, this.checkedall4, this.checkedall5);
      }

      this.checkedall = checkedArray.length === checkedAllArray.length
      this.checkedhalf = checkedArray.length > 0 && checkedArray.length < checkedAllArray.length
      // 更新校验
      this.updatevalidate()
    },
    // 错敏分类 - 左侧 - 点击 文本
    clickLeftTxt(item){
      this.activeClassify = item.value
    },
    // 错敏分类 - 右侧 - 点击子项 - 整合
    clickTwoLevel(list, checkedArr, errorArr, checkedAllArr){
      // 重置已勾选的项
      checkedArr.length = 0;  // 清空 checkedArr

      // 切换当前项的勾选状态
      this.$set(list, 'checked', !list.checked);

      // 更新 checkedArr，获取所有勾选的项
      checkedArr.push(...errorArr.filter(it => it.checked).map(it => it.value));

      // 查询二级子项，匹配的父级，并更新父级勾选状态
      const matchIndex = this.errorclassifyArr.findIndex(it => it.value === list.key);
      
      if (checkedArr.length === 0) {
        this.$set(this.errorclassifyArr[matchIndex], 'checked', false);
        this.$set(this.errorclassifyArr[matchIndex], 'checkedhalf', false);
      } else if (checkedArr.length === checkedAllArr.length) {
        this.$set(this.errorclassifyArr[matchIndex], 'checked', true);
        this.$set(this.errorclassifyArr[matchIndex], 'checkedhalf', false);
      } else {
        this.$set(this.errorclassifyArr[matchIndex], 'checked', false);
        this.$set(this.errorclassifyArr[matchIndex], 'checkedhalf', true);
      }

      // 更新全选的状态
      this.updateAllCheck();

      return checkedArr;  // 返回更新后的 checkedArr 即每个二级选项选中的值
    },
    // 错敏分类 - 右侧 - 点击子项 - 领导人核心
    clickOne(list){
      this.checked1 = this.clickTwoLevel(list, this.checked1, this.errorarr1, this.checkedall1)
    },
    // 错敏分类 - 右侧 - 点击子项 - 重大节点
    clickTwo(list){
      this.checked2 = this.clickTwoLevel(list, this.checked2, this.errorarr2, this.checkedall2)
    },
    // 错敏分类 - 右侧 - 点击子项 - 政治安全
    clickThree(list){
      this.checked3 = this.clickTwoLevel(list, this.checked3, this.errorarr3, this.checkedall3)
    },
    // 错敏分类 - 右侧 - 点击子项 - 社会民生
    clickFour(list){
      this.checked4 = this.clickTwoLevel(list, this.checked4, this.errorarr4, this.checkedall4)
    },
    // 错敏分类 - 右侧 - 点击子项 - 一般错别字
    clickSix(list){
      this.checked6 = this.clickTwoLevel(list, this.checked6, this.errorarr6, this.checkedall6)
    },
    handlerErrorClassity(){
      this.isShowErrorClassity = !this.isShowErrorClassity
    },
    handlerLevel(){
      this.isShowLevel = !this.isShowLevel
    },
    changeLevel(item,status){
      this.levelChecked = []
      if(status === 1){
        this.$set(item, 'isactive', !item.isactive)
        this.levelChecked = this.levelArr.filter(it => it.isactive).map(it => it.value)
      }else if(status === 2){
        this.levelChecked = this.levelArr.filter(it => it.isactive).map(it => it.value)
        Toast({
          type: 'html',
          message: '<div>严重表述错误<br>不支持取消推送！</div>'
        })
      }
    },
    handlerMedia(){
      this.isShowMdeia = !this.isShowMdeia
    },
    changeMedia(item){
      this.mediaChecked = []
      if(item.type === 'all'){
        // 全部时，全部高亮，其他项取消高亮
        this.mediaTypeArr.forEach(it => {
          this.$set(it, 'isactive', false)
        })
        this.$set(item, 'isactive', true)
        this.mediaChecked = this.mediaAllOps
      }else{
        // 其他项，没都选中时（部分选中），全部取消高亮
        this.$set(this.mediaTypeArr[0],'isactive', false)
        // 其他项，处理单选和多选情况
        const selectedItems = this.mediaTypeArr.filter(it => it.isactive && it.type !== 'all')
        // 其他项，只有一个高亮，点选取消高亮时，则提示至少选择一项  
        if (selectedItems.length === 1 && item.isactive && item.type === selectedItems[0].type) {
          this.$set(item, 'isactive', true);
          Toast({
            type: 'html',
            message: '<div>媒体类型不能为空，<br>至少选择一项！</div>'
          })
          this.mediaChecked = [item.type]
        } else {
          // 更新当前项的选中状态
          this.$set(item, 'isactive', !item.isactive)
          // 更新选中的媒体类型数组
          this.mediaChecked = this.mediaTypeArr
            .filter(it => it.isactive && it.type !== 'all')
            .map(it => it.type)
          // 其他项，都选中时，全部高亮，其他项高亮取消
          if (this.mediaChecked.length === this.mediaTypeArr.length - 1) {
            this.mediaTypeArr.forEach(it => {
              this.$set(it, 'isactive', false)
            })
            this.$set(this.mediaTypeArr[0], 'isactive', true)
            this.mediaChecked = this.mediaAllOps
          }
        }
      }
    },
    goToAccountlist(){
      this.$router.push({
        name: "accountlist",
        query: {
          code: this.$route.query.code || '',
          state: this.$route.query.state || '',
          openId: localStorage.getItem("wlgl-openId")
        }
      })
    },
    changeZombie(item){
      this.zombiesiteSource = []
      // 其他项，处理单选和多选情况
      const selectedItems = this.zombieArr.filter(it => it.isactive)
      // 其他项，只有一个高亮，点选取消高亮时，则提示至少选择一项  
      if (selectedItems.length === 1 && item.isactive) {
        this.$set(item, 'isactive', true);
        Toast({
          type: 'html',
          message: '<div>信源来源不能为空，<br>至少选择一项！</div>'
        })
        this.zombiesiteSource = [item.value]
      }else{
        // 更新当前项的选中状态
        this.$set(item, 'isactive', !item.isactive)
        // 更新选中的信源来源数组
        this.zombiesiteSource = this.zombieArr
          .filter(it => it.isactive)
          .map(it => it.value)
      }
    },
    validateParams(){
      let flag = true
      // 错敏分类 - 更新校验
      let sflag = this.updatevalidate()

      // 僵尸信源 - 更新校验
      const reg = /^[1-9]\d*$/
      const numZombiedays = Number(this.zombiedays)
      if (!reg.test(numZombiedays)) {
        this.zombieerrObj.isshow = true
        this.zombieerrObj.text = '请输入正整数！'
        flag = false
      } else if (numZombiedays > 366 || numZombiedays < 3) {
        this.zombieerrObj.isshow = true
        this.zombieerrObj.text = '请输入3~366之间的任意数字！'
        flag = false
      } else {
        this.zombieerrObj.isshow = false
        this.zombieerrObj.text = ''
        flag = true
      }

      return sflag && flag
    },
    // 确定
    handlerSave(){
      let flag = this.validateParams()
      let params = {
        id: this.checkInfoObj.id || '',
        openId: localStorage.getItem("wlgl-openId"),
        violationJson: { // 固定表述
          classifyLevelIdList: [
            {
              key: '1',
              value: this.checked1
            },
            {
              key: '2',
              value: this.checked2
            },
            {
              key: '3',
              value: this.checked3
            },
            {
              key: '4',
              value: this.checked4
            },
            {
              key: '5',
              value: this.checked5.length ? 1 : 0 // 有值存1，无存0
            }
          ],
          isOpen: this.fixedchecked ? 1 : 0,
          level: this.levelChecked,
          siteTypeList: {
            selected: this.mediaChecked
          }
        },
        corpseJson: { // 僵尸信源
          isOpen: this.zombiechecked ? 1 : 0,
          days: Number(this.zombiedays),
          existRecommend: true,
          siteSource: this.zombiesiteSource
        },
        scanJson: { // 网站扫描
          isOpen: this.sitescanchecked ? 1 : 0
        }
      }

      // 0关 1开
      if(this.checkInfoObj.open110 === 1){
        params.violationJson.classifyLevelIdList.push({
          key: '110',
          value: this.checked6
        })
      }

      if(flag){
        settingadd(params).then(res=>{
          this.errmsg = res.data.code
          if (res.data.code === 200){
            setTimeout(function () {
              Toast.success('预警设置保存成功！')
            }, 300)
          }else{
            setTimeout(function () {
              Toast.error('预警设置保存失败！')
            }, 300)
          }
        }).catch(err=>{
          Toast.clear()
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
  @import url("./wmset.css");
</style>